import { createApiClient } from './apiClient';
import { API_BASE_URL } from '../config';

export type ExchangeClientTrade = {
  _id?: string;
  id?: string;
  symbol?: string;
  exchange_client?: string;
};

export type SpotBalance = {
  asset?: string;
  disPlayName?: string;
  free?: string;
  locked?: string;
};

export type FuturesPosition = Record<string, string | number | null | undefined>;

export type AccountBalance = {
  free?: string;
  all?: string;
  err?: string | null;
};

type ExchangeClientTradesResponse = {
  success: boolean;
  trades?: ExchangeClientTrade[];
  exchangeData?: {
    spotBalances?: SpotBalance[];
    futuresPositions?: FuturesPosition[];
    futuresBalances?: AccountBalance;
    fundBalance?: AccountBalance;
  };
  message?: string;
};

type CloseExchangeClientPositionResponse = {
  success: boolean;
  data?: unknown;
  message?: string;
};

const exchangeClientTradesApi = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function fetchExchangeClientTrades(
  token: string | null,
  exchangeClientId: string | undefined,
  profileId: string | undefined
): Promise<ExchangeClientTradesResponse> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  // console.log('Fetching exchange client trades with:', {
  //   exchangeClientId,
  //   profileId,
  // });

  const params: Record<string, string> = {};
  if (exchangeClientId) params.exchangeClientId = exchangeClientId;
  if (profileId) params.profileId = profileId;

  const resp = await exchangeClientTradesApi.get<ExchangeClientTradesResponse>(
    '/exchange-client-trades',
    {
      headers,
      params: Object.keys(params).length > 0 ? params : undefined,
    }
  );

  console.log('Fetched exchange client trades response:', resp.data);
  
  return resp.data;
}

export async function closeExchangeClientPosition(
  token: string | null,
  params: {
    exchangeClientId: string;
    profileId: string;
    symbol?: string;
    market: 'spot' | 'futures';
    balance?: string;
  }
): Promise<CloseExchangeClientPositionResponse> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  console.log('Closing exchange client position with:', params);

  const resp = await exchangeClientTradesApi.post<CloseExchangeClientPositionResponse>(
    '/exchange-client-positions/close-position',
    params,
    { headers }
  );

  return resp.data;
}
